import { GameStats } from "./GameStats";
import {} from "./ImageEntity";
import { Slot } from "./Slot";
export var GAME_PERSPECTIVE;
(function (GAME_PERSPECTIVE) {
    GAME_PERSPECTIVE["THREE_D"] = "3D";
    GAME_PERSPECTIVE["TWO_D"] = "2D";
})(GAME_PERSPECTIVE || (GAME_PERSPECTIVE = {}));
;
export class ApiKey {
    id;
    key;
    active;
}
export class Game {
    id;
    name;
    // @TODO decide whether to use TAGS instead
    genre;
    setting;
    style;
    perspective;
    iconUrl;
    screenshots;
    // @TODO replace reference to publisher
    publisher;
    developer;
    slots;
    stats;
    constructor(data) {
        if (data) {
            for (let key in data) {
                this[key] = data[key];
            }
        }
    }
    isOwner(user) {
        return user.getCompanyId() == this.publisher || user.getCompanyId() == this.developer || user.isAdmin();
    }
}
